import { render, staticRenderFns } from "./TabBarComponent.vue?vue&type=template&id=c2a9d096&scoped=true&"
import script from "./TabBarComponent.vue?vue&type=script&lang=js&"
export * from "./TabBarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a9d096",
  null
  
)

export default component.exports